import React from 'react';
import './AboutUs.css';
import { Helmet } from 'react-helmet-async';
import Avatar from '@mui/material/Avatar';
import MaleAvatar  from '../assets/images/male.jpeg'
import FemaleVatar from '../assets/images/female.png'

// Sample team data
const teamMembers = [
  { name: 'Ronald Wekesa', title: 'Founder & CEO', avatar: MaleAvatar },
  { name: 'Antony Shiver', title: 'Co-founder & COO', avatar: MaleAvatar },
  { name: 'Festus', title: 'Product Manager', avatar: MaleAvatar },
  { name: 'Hellen', title: 'Customer Success & User Onboarding Lead', avatar: FemaleVatar },
  /*{ name: 'Dorine', title: 'Business Support & Coordination Assistant', avatar: FemaleVatar},
  { name: 'Frank', title: 'Digital Content & Marketing Coordinator ', avatar: MaleAvatar},*/
];

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us - RoshTech</title>
        <meta name="description" content="Learn about RoshTech, our mission, vision, story, and the team building Africa's digital future." />
      </Helmet>

      <div className="about-container">
        <section className="hero-section">
          <h1>About RoshTech</h1>
          <p>RoshTech is a technology company dedicated to developing innovative, market-driven software solutions tailored to African businesses, institutions, and communities. Our platforms are built to address local challenges and drive digital transformation.
</p>
        </section>

        <section className="mission-vision">
          <div className="card mission">
            <h2>Our Mission</h2>
            <p>To empower businesses and institutions with accessible, reliable, and scalable software solutions</p>
          </div>
          <div className="card vision">
            <h2>Our Vision</h2>
            <p>To be Africa’s leading force in digital transformation, enabling inclusive growth through innovative technology.</p>
          </div>
        </section>

        <section className="our-story">
          <h2>Our Story</h2>
          <p>
           {/* RoshTech began with a vision to transform how African organizations adopt technology. From humble beginnings,
            we've grown into a trusted developer of intelligent software solutions tailored for local challenges—from financial
            management tools to community-based applications. Each step has been driven by our commitment to impact and excellence.The company was registered in Keny in  2022.*/}
            
            RoshTech started with a bold vision: to transform how African organizations embrace digital tools. From small beginnings, we’ve evolved into creators of powerful software used across industries. We’re driven by passion, impact, and purpose.

          </p>
        </section>

        <section className="team-section">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <Avatar
                  alt={member.name}
                  src={member.avatar}
                  sx={{ width: 100, height: 100 }}
                />
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section">
  <h3>Want to work with us or learn more?</h3>
  <p>Reach out to explore how RoshTech can support your digital goals.</p>
  <a href="/contact">Contact Us</a>
</section>

      </div>
    </>
  );
};

export default AboutUs;
